import React from 'react';
import { Section } from '../Section';
import { Heading2 } from '../Heading2';
import { FadeUp } from '../FadeUp';
const rows: React.ReactNode[] = [<>
    Your kid <span className="text-pain" data-id="element-169" data-mp="28xpfs5oq6x62">tunes you out</span>, and you're exhausted from{' '}
    <strong className="font-extrabold" data-id="element-170" data-mp="2dtnz3ev75ozm">repeating yourself for the tenth time</strong>.
  </>, <>
    You <span className="text-pain" data-id="element-171" data-mp="2hxvm97m0awvq">yell at your kid</span>… and then{' '}
    <strong className="font-extrabold" data-id="element-172" data-mp="2mum1jspzlog3">feel awful about it</strong> for the rest of the day.
  </>, <>
    You've asked <span className="text-pain" data-id="element-173" data-mp="2rt5s66fizoes">a hundred times</span> and the same things{' '}
    <strong className="font-extrabold" data-id="element-174" data-mp="2wmi4bh30q2qn">still don't get done</strong>.
  </>, <>
    You want to parent with <strong className="font-extrabold" data-id="element-175" data-mp="31j8j81336sah">patience and connection</strong>,
    but most days it{' '}
    <span className="text-pain underline decoration-2 underline-offset-[4px]" data-id="element-176" data-mp="35ng8q0hdcc9r">
      feels impossible
    </span>
    .
  </>, <>
    <strong className="font-extrabold" data-id="element-177" data-mp="3aj5e4kg2kndz">You love your kid more than anything</strong>, but{' '}
    <span className="text-pain" data-id="element-178" data-mp="20po3owifbstl">you don't feel like the parent you wanted to be</span>.
  </>];
export function Pain() {
  return <Section data-id="element-179" data-mp="1rnewafigcfkf">
      <FadeUp data-id="element-180" data-mp="1rn57uwd22ggu">
        <Heading2 data-id="element-181" data-mp="1ropzad42pjah">
          This <em className="italic" data-id="element-182" data-mp="1rnx2o4ytwa62">Mega Kit</em> is for you if…
        </Heading2>

        <ul className="mx-auto mt-10 max-w-[520px] space-y-[26px]" data-id="element-183" data-mp="1mpvifgpo24t0">
          {rows.map((row, index) => <li key={index} className="flex items-start gap-3 text-left text-[17px]" data-id="element-184" data-mp="2kbsw90t3plym" data-mpi={index}>
              <span aria-hidden="true" className="flex-none text-[18px] leading-[1.6] text-star" data-id="element-185" data-mp="2fekbcsgkj3to">
                ★
              </span>
              <span data-id="element-186" data-mp="2akg6ceqv55v8">{row}</span>
            </li>)}
        </ul>
      </FadeUp>
    </Section>;
}